import {fromJS, Map } from 'immutable';
import config from 'config';
import actions from 'redux/constants/admin/mailing';
import history from '../../../../history';
import moment from 'moment';
import {checkJsonResponse, checkJsonResponseWithMessage, logErrorConsole} from 'utils/actions';

const checkLevelFilter = level => {
  if(!level) return
  return `&hierarchy_level=${level}`
}

export const changeMailValue = (data, key) => ({
	type: actions.SET_MAIL_ITEM_VALUE,
	key,
	data
});

export const changeCheckbox = (data) => ({
  type: actions.SUBMIT_ALL_STAFF,
  data
});

export const changeResponsibleStaff = (data, key) => ({
	type: actions.CHANGE_RESPONSIBLE_STAFF,
	key,
	data
})

export const attachFile = file => (dispatch) => {
  dispatch({
    type: actions.ATTACH_FILE,
    data: file,
  });
}; 

export const changeStaffAll = (boolType, level='') => (dispatch, getState) => {
	const options = {
    headers: {
     "Authorization": "Token " + getState().auth.get('token'),
	 	}
 	}
  fetch(`${config.apiHost}/staff/?is_responsible=1${checkLevelFilter(level)}`, options)
  .then(checkJsonResponse)
  .then((json) => {
		const data = fromJS(json.results.map(item => {
			item['checked'] = boolType;
			return item
		}))

    dispatch({
      type: actions.LOAD_RESPONSIBLE_STAFF,
      data
    });
  })
  .catch(e => console.log(e))
}

const mailsAreLoading = (data) => ({
	type: actions.MAILS_ARE_LOADING,
	data
})

export const mailChangeItem = (data) => ({
	type: actions.SET_MAIL_ITEM,
	data
});

export const mailSubmitError = (data) => ({
	type: actions.SET_MAIL_ERROR,
	data
});

export const mailIsSubmitting = (data) => ({
	type: actions.SET_MAIL_IS_LOADING,
	data
});

export const mailCleanStore = () => (dispatch) => {
  dispatch(mailChangeItem(new Map({
    comment_mailing: '',
  })));
}

export const sendMailUsersOperatorFail = data => ({
  type: actions.SEND_MAIL_USER_OPERATOR_FAIL,
  data
})

export const sendMailUsersOperatorSuccess = data => ({
  type: actions.SEND_MAIL_USER_OPERATOR_SUCCESS,
  data
})

export const cleanMailStore = () => ({
  type: actions.CLEAN_MAIL_STORE
})

export const sendMailUsersOperatorSubmitting = data => ({
  type: actions.SEND_MAIL_USER_OPERATOR_SUBMITTING,
  data
})

export const loadMails = (limit, offset) => (dispatch, getState) => {
	dispatch(mailsAreLoading(true))
  const options = {
    headers: {
      "Authorization": "Token " + getState().auth.get('token'),
    },
  }
  fetch(`${config.apiHost}/mailing/?limit=${limit}&offset=${offset}`, options)
  .then(checkJsonResponse)
  .then((json) => {
    const data = fromJS(json);
    dispatch({
      type: actions.LOAD_MAILS,
      data
    });
		dispatch(mailsAreLoading(false))
  })
  .catch(logErrorConsole)
};


export const searchMailsAdmin = (start_date, end_date, limit, offset) => (dispatch, getState) => {
	const date_start = start_date.format("YYYY-MM-DDTHH:mm:ss");
  const date_end = end_date.format("YYYY-MM-DDT23:59:59");
	dispatch(mailsAreLoading(true))
  const options = {
    headers: {
      "Authorization": "Token " + getState().auth.get('token'),
    },
  }
  fetch(`${config.apiHost}/mailing_user/?time_deadline__gte=${date_start}Z&time_deadline__lte=${date_end}Z&limit=${limit}&offset=${offset}`, options)
  .then(checkJsonResponse)
  .then((json) => {
    const data = fromJS(json);
		dispatch({
      type: actions.LOAD_MAILS,
      data
    });
		dispatch(mailsAreLoading(false))
  })
  .catch(logErrorConsole)
};


export const searchMailingAdmin = (start_date, end_date, limit, offset) => (dispatch, getState) => {
	const date_start = start_date.format("YYYY-MM-DDTHH:mm:ss");
  const date_end = end_date.format("YYYY-MM-DDT23:59:59");
	dispatch(mailsAreLoading(true))
  const options = {
    headers: {
      "Authorization": "Token " + getState().auth.get('token'),
    },
  }
  fetch(`${config.apiHost}/mailing/?time_deadline__range=${date_start}Z,${date_end}Z&limit=${limit}&offset=${offset}`, options)
  .then(checkJsonResponse)
  .then((json) => {
    const data = fromJS(json);
		dispatch({
      type: actions.LOAD_MAILS,
      data
    });
		dispatch(mailsAreLoading(false))
  })
  .catch(logErrorConsole)
};



export const searchMails = (start_date, end_date, status, limit, offset) => (dispatch, getState) => {
	const user_id = getState().auth.get('user').get('id');
	const date_start = start_date.format("YYYY-MM-DDTHH:mm:ss");
  const date_end = end_date.format("YYYY-MM-DDT23:59:59");
	dispatch(mailsAreLoading(true))
  const options = {
    headers: {
      "Authorization": "Token " + getState().auth.get('token'),
    },
  }
  fetch(`${config.apiHost}/mailing_user/?user=${user_id}&status__isnull=${status}&time_deadline__gte=${date_start}Z&time_deadline__lte=${date_end}Z&limit=${limit}&offset=${offset}`, options)
  .then(checkJsonResponse)
  .then((json) => {
    const data = fromJS(json);
		dispatch({
      type: actions.LOAD_OPERATOR_MAILS,
      data
    });
		dispatch(mailsAreLoading(false))
  })
  .catch(logErrorConsole)
};

export const loadMailDetail = (id) => (dispatch, getState) => {
	dispatch(mailsAreLoading(true));
  const options = {
    headers: {
      "Authorization": "Token " + getState().auth.get('token'),
    },
  }
  fetch(`${config.apiHost}/mailing/${id}/`,options)
  .then(checkJsonResponse)
  .then((json) => {
    const data = fromJS(json);
    dispatch({
      type: actions.LOAD_MAIL_DETAIL,
      data
    });
		dispatch(mailChangeItem(data))
		dispatch(mailsAreLoading(false));
  })
  .catch(logErrorConsole)
};




export const loadMailUsers = (id) => (dispatch, getState) => {
  const options = {
    headers: {
      "Authorization": "Token " + getState().auth.get('token'),
    }
  }
  fetch(`${config.apiHost}/mailing_user/?mailing=${id}`, options)
  .then(checkJsonResponse)
  .then((json) => {
    const data = fromJS(json);
    dispatch({
      type: actions.LOAD_MAIL_USERS,
      data
    })
  })
  .then(logErrorConsole)
};

export const loadMailUsersOperator = (id) => (dispatch, getState) => {
	const user_id = getState().auth.get('user').get('id');
  const options = {
    headers: {
      "Authorization": "Token " + getState().auth.get('token'),
    }
  }
  fetch(`${config.apiHost}/mailing_user/?mailing=${id}&user=${user_id}`, options)
  .then(checkJsonResponse)
  .then((json) => {
    const data = fromJS(json);
    dispatch({
      type: actions.LOAD_MAIL_USERS,
      data
    })
  })
  .then(logErrorConsole)
};


export const loadMailJournal = (id) => (dispatch, getState) => {
  const options = {
    headers: {
      "Authorization": "Token " + getState().auth.get('token'),
    }
  }
  fetch(`${config.apiHost}/mailing_journal/?mailing=${id}`, options)
  .then(checkJsonResponse)
  .then((json) => {
    const data = fromJS(json);
    dispatch({
      type: actions.LOAD_MAIL_JOURNAL,
      data
    })
  })
  .then(logErrorConsole)
};




export const submitNewMail = (url, document_id,  id) => (dispatch, getState) => {
	dispatch(mailIsSubmitting(true))
  let method = id ? 'put' : 'post';
  let path = id ? `${config.apiHost}/mailing/${id}/` : `${config.apiHost}/mailing/`;
  const options = {
    method,
    headers: {
      "Authorization": "Token " + getState().auth.get('token'),
			"Content-type": 'application/json'
    },
    body: JSON.stringify({
      time_deadline: getState().adminMails.get('mailItem').get('time_mailing') || moment(),
      comment_mailing: getState().adminMails.get('mailItem').get('comment_mailing'),
			document_list: [{document: document_id}]
    })
  }
  fetch(path, options)
  .then(checkJsonResponse)
  .then((json) => {
    const urlToRedirect = `${url}${json.id}`
    if(id) history.push(urlToRedirect)
    dispatch(submitNewUsers(json.id, urlToRedirect))
  })
  .catch(e => {
    dispatch(mailSubmitError(true));
  })
  .then(() => {
    dispatch(mailIsSubmitting(false))
  })
}



export const submitNewUsers = (id, url) => (dispatch, getState) => {
	const users = getState().adminMails.get('responsibleStaff').filter(item => item.get('checked') === true);
	const staff = users.map((item, i) => {
		let method = 'post';
	  let path = `${config.apiHost}/mailing_user/`;

	  const options = {
	    method,
	    headers: {
	      "Authorization": "Token " + getState().auth.get('token'),
				"Content-type": 'application/json'
	    },

	    body: JSON.stringify({
				status: null,
				mailing: id,
				responsible_staff: item.get('id')
	    })
	  }
		return fetch(path, options)
		  .then(checkJsonResponse)
		  .catch(logErrorConsole)
	});
	Promise.all(staff)
    .then(json => {
      history.push(url)
    })
    .catch(logErrorConsole)
}




export const submitAllResponsibleStaff = (id) => (dispatch, getState) => {
	let method = 'post';
	const options = {
		method,
		headers: {
			"Authorization": "Token " + getState().auth.get('token'),
			"Content-type": 'application/json'
		},
		body: JSON.stringify({
			mailing: id
		})
	}
	fetch(`${config.apiHost}/mailing_user/all/`, options)
	.then(checkJsonResponse)
	.then(json => {

	})
	.then(logErrorConsole)
}


export const deleteMail = (id) => (dispatch, getState) => {
  const options = {
    method: "delete",
    headers: {
       "Authorization": "Token " + getState().auth.get('token'),
    }
  };
  fetch(`${config.apiHost}/mailing/${id}/`, options)
  .then(response => {
    if (!response.ok) {
      throw Error(response.statusText);
    }
    return null;
  })
  .then(() => {
    history.goBack();
  })
  .catch(e => {
    console.log(e);
  })
};



export const changeMailComment = (data) => ({
	type: actions.CHANGE_MAIL_COMMENT,
	data
});

export const loadUserAnswer = (mail_id) => (dispatch, getState) => {
	const options = {
    headers: {
       "Authorization": "Token " + getState().auth.get('token'),
    }
  };
	fetch(`${config.apiHost}/mailing_user/?mailing=${mail_id}`, options)
	.then(response => {
    if (!response.ok) {
      throw Error(response.statusText);
    }
    return null;
  })
  .then((json) => {
		dispatch({
			type: actions.LOAD_USER_ANSWER,
			data: fromJS(json)
		})
  })
  .catch(e => {
    console.log(e);
  })
}
 

export const sendMailAnswer = (mail_id, id) => (dispatch, getState) => {
  dispatch(sendMailUsersOperatorFail(false))
  dispatch(sendMailUsersOperatorSuccess(false))
  dispatch(sendMailUsersOperatorSubmitting(true))
	let body
  let headers = {
      "Authorization": "Token " + getState().auth.get('token'),
    }
  if(getState().adminMails.get('attachedFile')){
    body = new FormData();
    body.append('comment', getState().adminMails.get('mailComment'));
    body.append('file', getState().adminMails.get('attachedFile'));
  } else {
    body = JSON.stringify({
      comment: getState().adminMails.get('mailComment')
    })
    headers["Content-type"]='application/json'
  }


	const options = {
    method: "put",
    headers,
		body
  };
	fetch(`${config.apiHost}/mailing_user/${mail_id}/`, options)
  .then(checkJsonResponseWithMessage)
  .then(response => {
		dispatch(loadMailUsersOperator(id))
    dispatch(sendMailUsersOperatorSuccess(true))
  })
  .catch(e => {
    dispatch(sendMailUsersOperatorFail(e))
  })
  .then(() => dispatch(sendMailUsersOperatorSubmitting(false)))
};



export const loadResponsibleStaff = (level='', limit='', offset='') => (dispatch, getState) => {
	const options = {
    headers: {
     "Authorization": "Token " + getState().auth.get('token'),
	 	}
 	}
  fetch(`${config.apiHost}/staff/?is_responsible=true&limit=${limit}&offset=${offset}${checkLevelFilter(level)}`, options)
  .then(checkJsonResponse)
  .then((json) => {
		const data = fromJS(json.results.map(item => {
			item['checked'] = false;
			return item
		}))

    dispatch({
      type: actions.LOAD_RESPONSIBLE_STAFF,
      data
    });
  })
  .catch(e => console.log(e))
};


export const loadMailsByUser = (limit, offset) => (dispatch, getState) => {
	const user_id = getState().auth.get('user').get('id');
	const options = {
    headers: {
     "Authorization": "Token " + getState().auth.get('token'),
	 	}
 	}
  fetch(`${config.apiHost}/mailing_user/?user=${user_id}&limit=${limit}&offset=${offset}`, options)
  .then(checkJsonResponse)
  .then((json) => {
		const data = fromJS(json);
    dispatch({
      type: actions.LOAD_OPERATOR_MAILS,
      data
    });
  })
  .catch(e => console.log(e))
}



// WEBPACK FOOTER //
// ./src/redux/actions/admin/mailing/index.js